import { createAction, props } from '@ngrx/store';
import { IdentityProviderMessagingTokenParticipant } from '@repo/shared/src/services/identity-provider/identity-provider.types';

export const setParticipantList = createAction(
  '[Participants] Set Participant List',
  props<{ participants: IdentityProviderMessagingTokenParticipant[] }>(),
);

export const setCurrentParticipant = createAction(
  '[Participants] Set Current Participant',
  props<{ participant: IdentityProviderMessagingTokenParticipant }>(),
);
